import { style } from '@vanilla-extract/css'

const button = style({
  boxSizing: 'border-box',
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontWeight: '700',
  fontSize: '13px',
  lineHeight: '1.5',
  textAlign: 'center',
  textDecoration: 'none',
  color: 'white',
  backgroundColor: '#252525',
  borderRadius: '32px',
  cursor: 'pointer',
  selectors: {
    '&:disabled': {
      backgroundColor: '#CCCCCC',
    },
  },
})

const small = style({
  fontSize: '13px',
  padding: '8px 16px',
})

const medium = style({
  fontSize: '18px',
  padding: '16px 24px',
})

const primary = style({
  backgroundColor: '#E46327',
})

const danger = style({
  backgroundColor: '#ED0006',
})

const fluid = style({
  width: '100%',
})

export const styles = {
  button,
  small,
  medium,
  primary,
  danger,
  fluid,
}
